// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getPipProductColumns = () => ({
    listColumns: [
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'status',
            key: translate('STATUS')
        },
        {
            id: 'responsibleAccount',
            key: translate('RESPONSIBLE_ACCOUNT')
        },
        {
            id: 'leadAccount',
            key: translate('LEAD_ACCOUNT')
        },
        {
            id: 'dealerLocation',
            key: translate('DEALER_LOCATION')
        },
        {
            id: 'type',
            key: translate('TYPE')
        },
        {
            id: 'metric',
            key: translate('METRIC')
        },
        {
            id: 'pipNumber',
            key: translate('PIP_NUMBER')
        },
        {
            id: 'pipProgram',
            key: translate('PIP_PROGRAM')
        },
        {
            id: 'expires',
            key: translate('EXPIRES')
        },
        {
            id: 'terminates',
            key: translate('TERMINATES')
        },
        {
            id: 'dtacSolution',
            key: translate('DTAC_SOLUTION')
        },
        {
            id: 'model',
            key: translate('MODEL')
        },
        {
            id: 'participant',
            key: translate('PARTICIPANT')
        },
        {
            id: 'pipStatus',
            key: translate('PIP_STATUS')
        },
        {
            id: 'pipCompletionStatus',
            key: translate('PIP_COMPLETION_STATUS')
        },
        {
            id: 'comments',
            key: translate('COMMENTS')
        },
        {
            id: 'customerName',
            key: translate('CUSTOMER_NAME')
        },
        {
            id: 'street1',
            key: translate('STREET_1')
        },
        {
            id: 'street2',
            key: translate('STREET_2')
        },
        {
            id: 'city',
            key: translate('CITY')
        },
        {
            id: 'region',
            key: translate('REGION')
        },
        {
            id: 'postalCode',
            key: translate('POSTAL_CODE')
        },
        {
            id: 'phone',
            key: translate('PHONE')
        },
        {
            id: 'email',
            key: translate('EMAIL')
        },
        {
            id: 'country',
            key: translate('COUNTRY')
        },
        {
            id: 'laborHours',
            key: translate('LABOR_HOURS')
        },
        {
            id: 'otherCredit1',
            key: translate('OTHER_CREDIT_1')
        },
        {
            id: 'amount1',
            key: translate('AMOUNT_1')
        },
        {
            id: 'unit1',
            key: translate('UNIT_1')
        },
        {
            id: 'part1',
            key: translate('PART_1')
        },
        {
            id: 'quantity1',
            key: translate('QUANTITY_1')
        },
        {
            id: 'part2',
            key: translate('PART_2')
        },
        {
            id: 'quantity2',
            key: translate('QUANTITY_2')
        },
        {
            id: 'part3',
            key: translate('PART_3')
        },
        {
            id: 'quantity3',
            key: translate('QUANTITY_3')
        },
        {
            id: 'part4',
            key: translate('PART_4')
        },
        {
            id: 'quantity4',
            key: translate('QUANTITY_4')
        },
        {
            id: 'part5',
            key: translate('PART_5')
        },
        {
            id: 'quantity5',
            key: translate('QUANTITY_5')
        },
        {
            id: 'part6',
            key: translate('PART_6')
        },
        {
            id: 'quantity6',
            key: translate('QUANTITY_6')
        },
        {
            id: 'part7',
            key: translate('PART_7')
        },
        {
            id: 'quantity7',
            key: translate('QUANTITY_7')
        },
        {
            id: 'part8',
            key: translate('PART_8')
        },
        {
            id: 'quantity8',
            key: translate('QUANTITY_8')
        },
        {
            id: 'part9',
            key: translate('PART_9')
        },
        {
            id: 'quantity9',
            key: translate('QUANTITY_9')
        },
        {
            id: 'part10',
            key: translate('PART_10')
        },
        {
            id: 'quantity10',
            key: translate('QUANTITY_10')
        },
        {
            id: 'otherCredit2',
            key: translate('OTHER_CREDIT_2')
        },
        {
            id: 'amount2',
            key: translate('AMOUNT_2')
        },
        {
            id: 'unit2',
            key: translate('UNIT_2')
        },
        {
            id: 'otherCredit3',
            key: translate('OTHER_CREDIT_3')
        },
        {
            id: 'amount3',
            key: translate('AMOUNT_3')
        },
        {
            id: 'unit3',
            key: translate('UNIT_3')
        }
    ],
    listId: 'pipProducts'
});



// WEBPACK FOOTER //
// ./src/pip/shared/services/pip-product-excel-columns.js